/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Human_Hand_OffInputs */

const en_svchip_human_hand_off = /** @type {(inputs: Svchip_Human_Hand_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Human hand-off`)
};

const ar_svchip_human_hand_off = /** @type {(inputs: Svchip_Human_Hand_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسليم بشري`)
};

const bn_svchip_human_hand_off = /** @type {(inputs: Svchip_Human_Hand_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হিউম্যান হ্যান্ড-অফ`)
};

const de_svchip_human_hand_off = /** @type {(inputs: Svchip_Human_Hand_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menschliche Übergabe`)
};

const es_svchip_human_hand_off = /** @type {(inputs: Svchip_Human_Hand_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traspaso humano`)
};

const fr_svchip_human_hand_off = /** @type {(inputs: Svchip_Human_Hand_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transfert humain`)
};

const pt_svchip_human_hand_off = /** @type {(inputs: Svchip_Human_Hand_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transferência humana`)
};

const zh_svchip_human_hand_off = /** @type {(inputs: Svchip_Human_Hand_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人工切换`)
};

const tr_svchip_human_hand_off = /** @type {(inputs: Svchip_Human_Hand_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İnsan devri`)
};

const ru_svchip_human_hand_off = /** @type {(inputs: Svchip_Human_Hand_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Передача человека`)
};

const pl_svchip_human_hand_off = /** @type {(inputs: Svchip_Human_Hand_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przekazanie przez człowieka`)
};

/**
* | output |
* | --- |
* | "Human hand-off" |
*
* @param {Svchip_Human_Hand_OffInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_human_hand_off = /** @type {((inputs?: Svchip_Human_Hand_OffInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Human_Hand_OffInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_human_hand_off(inputs)
	if (locale === "bn") return bn_svchip_human_hand_off(inputs)
	if (locale === "de") return de_svchip_human_hand_off(inputs)
	if (locale === "es") return es_svchip_human_hand_off(inputs)
	if (locale === "fr") return fr_svchip_human_hand_off(inputs)
	if (locale === "pt") return pt_svchip_human_hand_off(inputs)
	if (locale === "zh") return zh_svchip_human_hand_off(inputs)
	if (locale === "tr") return tr_svchip_human_hand_off(inputs)
	if (locale === "ru") return ru_svchip_human_hand_off(inputs)
	if (locale === "pl") return pl_svchip_human_hand_off(inputs)
	return en_svchip_human_hand_off(inputs)
});